import Socket from "sockjs-client";
import Stomp from "stompjs";

class StompClient {
  constructor(socketUrl) {
    this.socketUrl = socketUrl;
    // Only transports the portal's CSP permits: the iframe/JSONP fallbacks are blocked by
    // default-src/script-src and would only log violations before reaching xhr-polling.
    // xhr-streaming is left out too: Cloudflare buffers the stream, so SockJS always gave up on it
    // after a few seconds and left an orphaned server session behind.
    this.socket = new Socket(socketUrl, null, {
      transports: ["websocket", "xhr-polling"],
    });
    this.stompClient = Stomp.over(this.socket);
    this.stompClient.debug = () => {};
  }
  connect(options = {}, onSocketConnected, onSocketError) {
    this.stompClient.connect(options, onSocketConnected, onSocketError);
  }

  subscribe(subscriptionUrl, onMessageReceived) {
    this.stompClient.subscribe(subscriptionUrl, onMessageReceived);
  }

  send(url, message) {
    this.stompClient.send(url, {}, JSON.stringify(message));
  }

  disconnect() {
    if (this.stompClient && this.stompClient.connected) {
      this.stompClient.disconnect();
    }
  }

  // Drops the underlying SockJS connection whatever state it is in (used before reconnecting).
  close() {
    if (this.socket) {
      this.socket.close();
    }
  }
}

export default StompClient;
